import { OWObject } from "../../../../OW.Remoting/Remoting/DataTypes/OWObject";
/**
   * Rozhraní, který může zamykat/odemykat záznamy
   * @includeToDoc
   */
export interface IExtendedLifeCycle {
    /**
     * Funkce pro zamykání/odemykání záznamů
     */
    onEditMethod: string;
    onCancelMethod: string;

    // metody
    unlockObject(object?: OWObject): Promise<boolean>;
    lockObject(object?: OWObject): Promise<boolean>;

}

export class IExtendedLifeCycle {
    private static _properties = ["onEditMethod", "onCancelMethod"];

    private static _methods = ["unlockObject", "lockObject"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
